<template>
  <keep-alive>
    <div class="ksm-flex" style="background-color:#fff">
      <ModusIndex :viewKey="'werbe'"></ModusIndex>
    </div>
  </keep-alive>
</template>

<script>
import ModusIndex from "../components/modus/ModusIndex";
export default {
  name: "merzwerbe",
  components: {
    ModusIndex
  },
  created: function() {},

  data() {
    return {};
  },

  mounted: function() {
  
  }
};
</script>

<style lang="scss"
 scoped>
</style>


// WEBPACK FOOTER //
// MerzWerbe.vue?3f5f81f0